(() => {
  'use strict';
  const cfg = window.DuxfordConfig || {};
  const $ = (s, r=document) => r.querySelector(s);
  const $$ = (s, r=document) => [...r.querySelectorAll(s)];
  const emit = (name, detail={}) => document.dispatchEvent(new CustomEvent(name,{detail}));
  const rootUrl = (path='') => `${cfg.root || '/'}${String(path).replace(/^\//,'')}`;
  const money = (cents, format) => {
    const n = Number(cents || 0) / 100;
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency: window.Shopify?.currency?.active || 'USD'}).format(n); }
    catch { return n.toFixed(2); }
  };
  const lock = (on) => document.body.classList.toggle('dc-lock', !!on);
  const overlay = () => $('[data-dc-overlay]');
  const setPanelState = (el, open) => {
    if (!el) return;
    el.classList.toggle('is-open', !!open);
    el.setAttribute('aria-hidden', open ? 'false' : 'true');
  };
  const closeAll = () => {
    $$('[data-dc-drawer].is-open,[data-dc-search].is-open,[data-dc-cart].is-open').forEach(el=>setPanelState(el,false));
    $$('[data-pickup-drawer].is-open').forEach(el=>{el.classList.remove('is-open');el.setAttribute('aria-hidden','true')});
    overlay()?.classList.remove('is-open');
    lock(false);
  };

  document.addEventListener('click', (e) => {
    const menuOpen = e.target.closest('[data-dc-menu-open]');
    const searchOpen = e.target.closest('[data-dc-search-open]');
    const cartOpen = e.target.closest('[data-dc-cart-open]');
    if (menuOpen) {
      e.preventDefault();
      closeAll();
      setPanelState($('[data-dc-drawer]'), true);
      overlay()?.classList.add('is-open');
      lock(true);
    }
    if (searchOpen) {
      e.preventDefault();
      closeAll();
      const panel=$('[data-dc-search]');
      setPanelState(panel,true);
      lock(true);
      setTimeout(()=>$('input[type=search]',panel)?.focus(),80);
    }
    if (cartOpen) {
      if(cfg.cartMode === 'page') return;
      e.preventDefault();
      closeAll();
      setPanelState($('[data-dc-cart]'),true);
      overlay()?.classList.add('is-open');
      lock(true);
    }
    if (e.target.closest('[data-dc-close]') || e.target.matches('[data-dc-overlay]')) closeAll();
  });
  document.addEventListener('keydown',e=>{if(e.key==='Escape'){closeAll();$$('.dc-nav__item.is-focused').forEach(x=>x.classList.remove('is-focused'));$$('[data-newsletter-popup]:not([hidden])').forEach(pop=>pop._dcClose?.(true));const modal=$('[data-dc-modal]:not([hidden])');if(modal){modal.hidden=true;lock(false)}}});
  // Desktop touch navigation: first tap opens a dropdown, second tap follows the link.
  document.addEventListener('click',e=>{
    const link=e.target.closest('.dc-nav__item--has-dropdown > .dc-nav__link');
    if(!link || !matchMedia('(pointer: coarse)').matches || innerWidth<=768)return;
    const item=link.parentElement;
    if(!item.classList.contains('is-focused')){
      e.preventDefault();
      $$('.dc-nav__item.is-focused').forEach(x=>{if(x!==item)x.classList.remove('is-focused')});
      item.classList.add('is-focused');
    }
  });
  document.addEventListener('click',e=>{if(!e.target.closest('.dc-nav'))$$('.dc-nav__item.is-focused').forEach(x=>x.classList.remove('is-focused'))});
  document.addEventListener('click',e=>{
    const checkout=e.target.closest('[data-terms-required="true"]'); if(!checkout)return;
    const scope=checkout.closest('[data-dc-cart],form')||document; const terms=scope.querySelector('[data-cart-terms],.dc-cart-terms input');
    if(terms && !terms.checked){e.preventDefault();terms.focus();terms.closest('.dc-cart-terms')?.classList.add('is-required');}
  });

  // Header parity: preserve layout height, then reveal a fixed header after 250px.
  const headerCleanups = new WeakMap();
  const initHeader = header => {
    headerCleanups.get(header)?.();
    const space=header.closest('[data-dc-header-sticky-space]');
    if(!space || header.dataset.sticky !== 'true') return;
    let active=false;
    let forceStop=false;
    let raf=0;

    const megaFits = () => {
      let largest=0;
      $$('.dc-mega',header).forEach(menu=>{largest=Math.max(largest,menu.offsetHeight||0)});
      return innerHeight >= largest + 120;
    };
    const measure = () => {
      const overlayMode=space.classList.contains('dc-header-sticky-space--overlay');
      space.style.height=overlayMode ? '0px' : `${header.offsetHeight}px`;
      forceStop=!megaFits() || (innerWidth>=700 && innerHeight<=550);
      if(forceStop && active){active=false;header.classList.remove('is-opening','is-stuck')}
    };
    const applyScroll = () => {
      raf=0;
      if(forceStop) return;
      const shouldStick=scrollY>250;
      if(shouldStick===active) return;
      active=shouldStick;
      if(active){
        header.classList.add('is-stuck');
        requestAnimationFrame(()=>requestAnimationFrame(()=>{if(active)header.classList.add('is-opening')}));
      }else{
        header.classList.remove('is-opening','is-stuck');
      }
    };
    const onScroll=()=>{if(!raf)raf=requestAnimationFrame(applyScroll)};
    const onResize=()=>{measure();applyScroll()};
    measure();applyScroll();
    addEventListener('scroll',onScroll,{passive:true});
    addEventListener('resize',onResize,{passive:true});
    const cleanup=()=>{removeEventListener('scroll',onScroll);removeEventListener('resize',onResize);if(raf)cancelAnimationFrame(raf)};
    headerCleanups.set(header,cleanup);
  };
  const syncOverlayHeaderState=()=>document.body.classList.toggle('dc-overlaid-header',!!$('[data-dc-header][data-overlay=\"true\"]'));
  const reconcileCollectionOverlay=()=>{
    const marker=$('[data-dc-collection-header]');
    const header=$('[data-dc-header]');
    if(!marker||!header||header.dataset.overlayIntent!=='true')return;
    const enabled=marker.dataset.hasHero==='true';
    header.dataset.overlay=enabled?'true':'false';
    header.classList.toggle('is-overlay',enabled);
    header.closest('[data-dc-header-shell]')?.classList.toggle('dc-header-shell--overlay',enabled);
    header.closest('[data-dc-header-sticky-space]')?.classList.toggle('dc-header-sticky-space--overlay',enabled);
  };
  reconcileCollectionOverlay();
  $$('[data-dc-header]').forEach(initHeader);
  syncOverlayHeaderState();
  document.addEventListener('shopify:section:load',e=>{
    reconcileCollectionOverlay();
    $$('[data-dc-header]',e.target).forEach(initHeader);
    if(e.target?.querySelector?.('[data-dc-collection-header]')||e.target?.matches?.('[data-dc-collection-header]'))$$('[data-dc-header]').forEach(initHeader);
    syncOverlayHeaderState();
  });
  document.addEventListener('shopify:section:unload',e=>{$$('[data-dc-header]',e.target).forEach(h=>headerCleanups.get(h)?.());setTimeout(()=>{reconcileCollectionOverlay();syncOverlayHeaderState();},0);});

  // Announcement behavior: desktop shows all unless Compact is enabled; mobile always rotates.
  const announcementTimers = new WeakMap();
  const initAnnouncement = bar => {
    const old=announcementTimers.get(bar); if(old){clearInterval(old);announcementTimers.delete(bar)}
    const items=$$('[data-announcement-item]',bar); if(!items.length)return;
    let index=0;
    const compact=bar.dataset.compact==='true';
    const rotating=matchMedia('(max-width: 768px)').matches || compact;
    items.forEach((item,i)=>{item.hidden=rotating ? i!==0 : false});
    if(!rotating || items.length<2)return;
    const timer=setInterval(()=>{
      items[index].hidden=true;
      index=(index+1)%items.length;
      items[index].hidden=false;
    },Number(bar.dataset.speed||5)*1000);
    announcementTimers.set(bar,timer);
  };
  const initAnnouncements=()=>$$('[data-announcement]').forEach(initAnnouncement);
  initAnnouncements();
  let announcementResize;
  addEventListener('resize',()=>{clearTimeout(announcementResize);announcementResize=setTimeout(initAnnouncements,120)},{passive:true});
  document.addEventListener('shopify:section:load',e=>$$('[data-announcement]',e.target).forEach(initAnnouncement));
  document.addEventListener('shopify:block:select',e=>{
    const item=e.target?.closest?.('[data-announcement-item]');if(!item)return;
    const bar=item.closest('[data-announcement]');const timer=announcementTimers.get(bar);if(timer)clearInterval(timer);
    $$('[data-announcement-item]',bar).forEach(x=>x.hidden=x!==item);
  });

  document.addEventListener('shopify:block:deselect',e=>{const bar=e.target?.closest?.('[data-announcement]');if(bar)initAnnouncement(bar)});

  // Slideshow: independent fade engine with autoplay, editor support, keyboard and swipe.
  const slideshowStates = new WeakMap();
  const initSlideshow = slider => {
    slideshowStates.get(slider)?.destroy?.();

    const slides=$$('[data-slide]',slider);
    const dots=$$('[data-slide-dot]',slider);
    const prev=$('[data-slide-prev]',slider);
    const next=$('[data-slide-next]',slider);
    const pauseButton=$('[data-slide-pause]',slider.closest('[data-dc-slideshow-section]') || document);
    const delay=Math.max(1000,Number(slider.dataset.speedMs || 7000));
    const autoplay=slider.dataset.autoplay==='true' && slides.length>1;
    const abort=new AbortController();
    const signal=abort.signal;
    let index=Math.max(0,slides.findIndex(s=>s.classList.contains('is-active')));
    let timer=0;
    let editorPaused=false;
    let interactionPaused=false;
    let pointerStart=null;

    const resetBarAnimation = () => {
      if(slider.dataset.style!=='bars') return;
      const active=dots[index];
      if(!active) return;
      active.classList.remove('is-active');
      void active.offsetWidth;
      active.classList.add('is-active');
    };

    const show = (n,{restartBar=true}={}) => {
      if(!slides.length) return;
      const previous=index;
      index=(Number(n)+slides.length)%slides.length;
      slides.forEach(slide=>slide.classList.remove('is-leaving'));
      if(previous!==index && slides[previous]){
        const outgoing=slides[previous];
        outgoing.classList.add('is-leaving');
        setTimeout(()=>outgoing.classList.remove('is-leaving'),620);
      }
      slides.forEach((slide,i)=>{
        const active=i===index;
        slide.classList.toggle('is-active',active);
        slide.setAttribute('aria-hidden',active?'false':'true');
      });
      dots.forEach((dot,i)=>{
        const active=i===index;
        dot.classList.toggle('is-active',active);
        dot.setAttribute('aria-selected',active?'true':'false');
      });
      if(restartBar) resetBarAnimation();
    };

    const stop = () => { if(timer){clearTimeout(timer);timer=0;} };
    const schedule = () => {
      stop();
      if(!autoplay || editorPaused || interactionPaused || document.hidden) return;
      timer=setTimeout(()=>{show(index+1);schedule();},delay);
    };
    const restart = () => { schedule(); };
    const pause = permanent => { if(permanent){editorPaused=true;slider.classList.add('is-paused');} else interactionPaused=true; stop(); };
    const resume = permanent => { if(permanent){editorPaused=false;slider.classList.remove('is-paused');} else interactionPaused=false; schedule(); };

    dots.forEach((dot,n)=>dot.addEventListener('click',()=>{interactionPaused=false;show(n);restart();},{signal}));
    prev?.addEventListener('click',()=>{interactionPaused=false;show(index-1);restart();},{signal});
    next?.addEventListener('click',()=>{interactionPaused=false;show(index+1);restart();},{signal});

    slider.addEventListener('keydown',e=>{
      if(e.key==='ArrowLeft'){e.preventDefault();show(index-1);restart();}
      if(e.key==='ArrowRight'){e.preventDefault();show(index+1);restart();}
    },{signal});

    // The reference carousel keeps autoplay running while hovered/focused.
    // Only an explicit pause control, editor selection, visibility change or drag interrupts it.

    slider.addEventListener('pointerdown',e=>{
      if(e.pointerType==='mouse' && e.button!==0) return;
      if(e.target.closest('a,button,input,select,textarea')) return;
      pointerStart={x:e.clientX,y:e.clientY,id:e.pointerId};
      stop();
    },{signal});
    slider.addEventListener('pointerup',e=>{
      if(!pointerStart || pointerStart.id!==e.pointerId) return;
      const dx=e.clientX-pointerStart.x;
      const dy=e.clientY-pointerStart.y;
      pointerStart=null;
      if(Math.abs(dx)>45 && Math.abs(dx)>Math.abs(dy)*1.15){show(index+(dx<0?1:-1));}
      schedule();
    },{signal});
    slider.addEventListener('pointercancel',()=>{pointerStart=null;schedule();},{signal});

    if(pauseButton){
      pauseButton.addEventListener('click',()=>{
        const pressed=pauseButton.getAttribute('aria-pressed')==='true';
        pauseButton.setAttribute('aria-pressed',pressed?'false':'true');
        const label=$('[data-pause-label]',pauseButton);
        if(pressed){editorPaused=false;slider.classList.remove('is-paused');if(label)label.textContent='Pause slideshow';schedule();}
        else{editorPaused=true;slider.classList.add('is-paused');if(label)label.textContent='Play slideshow';stop();}
      },{signal});
    }

    const visibility=()=>{if(document.hidden)stop();else schedule();};
    document.addEventListener('visibilitychange',visibility,{signal});

    show(index);
    schedule();

    const state={
      show:n=>{show(n);},
      pause:()=>pause(true),
      resume:()=>resume(true),
      destroy:()=>{stop();abort.abort();slideshowStates.delete(slider);}
    };
    slideshowStates.set(slider,state);
    return state;
  };

  const initSlideshows = root => $$('[data-slideshow]',root || document).forEach(initSlideshow);
  initSlideshows(document);
  document.addEventListener('shopify:section:load',e=>initSlideshows(e.target));
  document.addEventListener('shopify:section:unload',e=>$$('[data-slideshow]',e.target).forEach(s=>slideshowStates.get(s)?.destroy?.()));
  document.addEventListener('shopify:block:select',e=>{
    const blockId=e.detail?.blockId;
    if(!blockId) return;
    $$('[data-slideshow]').forEach(slider=>{
      const slide=$(`[data-slide][data-block-id="${CSS.escape(blockId)}"]`,slider);
      if(!slide) return;
      const state=slideshowStates.get(slider) || initSlideshow(slider);
      state?.show(Number(slide.dataset.index||0));
      state?.pause();
    });
  });
  document.addEventListener('shopify:block:deselect',e=>{
    const blockId=e.detail?.blockId;
    if(!blockId) return;
    $$('[data-slideshow]').forEach(slider=>{
      if($(`[data-slide][data-block-id="${CSS.escape(blockId)}"]`,slider)) slideshowStates.get(slider)?.resume?.();
    });
  });


  // Testimonials: independent centered carousel matching the reference behavior.
  // No autoplay loop: with 3+ cards it advances once to card 2 after one second
  // so visitors immediately understand that the row is interactive.
  const testimonialStates = new WeakMap();
  const initTestimonials = root => {
    const slider=root.matches?.('[data-testimonials]') ? root : $('[data-testimonials]',root);
    if(!slider)return;
    testimonialStates.get(slider)?.destroy?.();
    const viewport=$('[data-testimonials-viewport]',slider), track=$('[data-testimonials-track]',slider);
    if(!viewport||!track)return;
    $$('[data-testimonial-clone]',track).forEach(x=>x.remove());
    const originals=$$('[data-testimonial-slide]:not([data-testimonial-clone])',track);
    const dots=$$('[data-testimonial-dot]',slider);
    if(!originals.length)return;
    const wrap=originals.length>3;
    const abort=new AbortController(), signal=abort.signal;
    let index=0, timeout=0, resizeTimer=0, start=null;

    if(wrap){
      const before=originals[originals.length-1].cloneNode(true);
      const after=originals[0].cloneNode(true);
      before.dataset.testimonialClone='true';after.dataset.testimonialClone='true';
      before.removeAttribute('data-block-id');after.removeAttribute('data-block-id');
      track.prepend(before);track.append(after);
    }

    const all=()=>$$('[data-testimonial-slide]',track);
    const selectClasses=()=>{
      originals.forEach((slide,i)=>slide.classList.toggle('is-selected',i===index));
      $$('[data-testimonial-clone]',track).forEach(x=>x.classList.remove('is-selected'));
      dots.forEach((dot,i)=>dot.classList.toggle('is-active',i===index));
    };
    const layout=(animate=true)=>{
      const visible=innerWidth<=768?1:3;
      const cell=viewport.clientWidth/visible;
      all().forEach(slide=>{slide.style.flexBasis=`${cell}px`;slide.style.width=`${cell}px`});
      track.style.transition=animate?'transform .5s ease':'none';
      if(wrap){
        const physical=index+1;
        const centerOffset=(visible/2-.5)*cell;
        track.style.transform=`translate3d(${centerOffset-physical*cell}px,0,0)`;
      }else{
        track.style.transform='translate3d(0,0,0)';
        track.style.justifyContent=originals.length<visible?'center':'flex-start';
      }
      selectClasses();
    };
    const goTo=n=>{index=(Number(n)+originals.length)%originals.length;layout(true)};

    dots.forEach((dot,i)=>dot.addEventListener('click',()=>{clearTimeout(timeout);goTo(i)},{signal}));
    viewport.addEventListener('pointerdown',e=>{
      if(e.pointerType==='mouse'&&e.button!==0)return;
      if(e.target.closest('a,button,input,select,textarea'))return;
      start={x:e.clientX,y:e.clientY,id:e.pointerId};
    },{signal});
    viewport.addEventListener('pointerup',e=>{
      if(!start||start.id!==e.pointerId)return;
      const dx=e.clientX-start.x,dy=e.clientY-start.y;start=null;
      if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy)*1.15){clearTimeout(timeout);goTo(index+(dx<0?1:-1))}
    },{signal});
    viewport.addEventListener('pointercancel',()=>{start=null},{signal});
    const onResize=()=>{clearTimeout(resizeTimer);resizeTimer=setTimeout(()=>layout(false),100)};
    addEventListener('resize',onResize,{signal,passive:true});
    layout(false);
    if(originals.length>2)timeout=setTimeout(()=>goTo(1),1000);

    const state={
      goTo,
      destroy:()=>{clearTimeout(timeout);clearTimeout(resizeTimer);abort.abort();testimonialStates.delete(slider)}
    };
    testimonialStates.set(slider,state);
  };
  $$('[data-testimonials]').forEach(initTestimonials);
  document.addEventListener('shopify:section:load',e=>$$('[data-testimonials]',e.target).forEach(initTestimonials));
  document.addEventListener('shopify:section:unload',e=>$$('[data-testimonials]',e.target).forEach(x=>testimonialStates.get(x)?.destroy?.()));
  document.addEventListener('shopify:block:select',e=>{
    const id=e.detail?.blockId;if(!id)return;
    $$('[data-testimonials]').forEach(slider=>{
      const slide=slider.querySelector(`[data-testimonial-slide][data-block-id="${CSS.escape(id)}"]`);
      if(slide)testimonialStates.get(slider)?.goTo(Number(slide.dataset.index||0));
    });
  });


  // Parallax is section-editor safe and uses a dedicated motion model for large image/text sections.
  let parallaxFrame=0;
  const reducedMotion=matchMedia('(prefers-reduced-motion: reduce)');
  const updateParallax=()=>{
    parallaxFrame=0;
    const mobile=innerWidth<=768;
    $$('[data-parallax="true"] [data-parallax-media]').forEach(el=>{
      const section=el.closest('[data-parallax="true"]');
      if(!section)return;
      const r=section.getBoundingClientRect();
      const visible=r.bottom>-200&&r.top<innerHeight+200;
      const isBackgroundFeature=el.dataset.parallaxKind==='background-feature'||section.hasAttribute('data-dc-background-feature');

      if(isBackgroundFeature){
        // This component uses a 160% tall image layer, giving enough overscan for a smooth,
        // slower-than-page movement without exposing empty edges. It is desktop-only.
        if(mobile||reducedMotion.matches){el.style.transform='none';return;}
        if(!visible)return;
        const sectionCenter=r.top+(r.height/2);
        const viewportCenter=innerHeight/2;
        const range=(innerHeight+r.height)/2;
        const progress=Math.max(-1,Math.min(1,(viewportCenter-sectionCenter)/range));
        const travel=Math.min(r.height*.22,170);
        const y=Math.round(progress*travel*10)/10;
        el.style.transform=`translate3d(0,${y}px,0)`;
        return;
      }

      if(!visible)return;
      const y=(r.top+r.height/2-innerHeight/2)*-.06;
      el.style.transform=`translate3d(0,${y}px,0) scale(1.08)`;
    });
  };
  const requestParallax=()=>{if(!parallaxFrame)parallaxFrame=requestAnimationFrame(updateParallax);};
  addEventListener('scroll',requestParallax,{passive:true});
  addEventListener('resize',requestParallax,{passive:true});
  reducedMotion.addEventListener?.('change',requestParallax);
  document.addEventListener('shopify:section:load',requestParallax);
  document.addEventListener('shopify:section:reorder',requestParallax);
  updateParallax();

  // Predictive search using the public endpoint + section rendering
  let searchAbort;
  document.addEventListener('input', async e => {
    const input=e.target.closest('[data-predictive-input]'); if(!input || !cfg.predictive) return;
    const panel=input.closest('[data-dc-search]'), target=$('[data-predictive-results]',panel), q=input.value.trim();
    if(q.length<2){target.innerHTML='';return}
    searchAbort?.abort(); searchAbort=new AbortController();
    try{
      const url=new URL(rootUrl('search/suggest'),location.origin);url.searchParams.set('q',q);url.searchParams.set('section_id','dc-predictive-search');url.searchParams.set('resources[type]',cfg.searchType||'product,collection,page,article');
      const res=await fetch(url,{signal:searchAbort.signal}); if(!res.ok) throw new Error('Search failed');
      const html=await res.text(); const doc=new DOMParser().parseFromString(html,'text/html'); target.innerHTML=$('[data-predictive-payload]',doc)?.innerHTML || '';
    }catch(err){if(err.name!=='AbortError') target.innerHTML='';}
  });

  // Quantity controls
  document.addEventListener('click', e=>{
    const b=e.target.closest('[data-qty-plus],[data-qty-minus]'); if(!b)return;
    const wrap=b.closest('[data-quantity]'), input=$('input',wrap); if(!input)return;
    const min=Number(input.min||1), max=Number(input.max||9999), step=Number(input.step||1); let v=Number(input.value||1)+(b.hasAttribute('data-qty-plus')?step:-step);v=Math.max(min,Math.min(max,v));input.value=v;input.dispatchEvent(new Event('change',{bubbles:true}));
  });
  document.addEventListener('change', e=>{ const q=e.target.closest('[data-product-quantity]'); if(!q)return; const root=q.closest('[data-product-root]'); const hidden=$('[data-buy-quantity]',root); if(hidden) hidden.value=Math.max(1,Number(q.value||1)); });

  const refreshCartSections = sections => {
    if(!sections) return;
    const drawerHtml=sections['dc-cart-drawer'];
    if(drawerHtml){
      const doc=new DOMParser().parseFromString(drawerHtml,'text/html');
      const fresh=$('[data-dc-cart]',doc), current=$('[data-dc-cart]'); if(fresh&&current) current.replaceWith(fresh);
      const count=doc.querySelector('[data-cart-count-source]')?.textContent?.trim();
      if(count!=null) $$('[data-cart-count]').forEach(x=>{x.textContent=count;x.hidden=Number(count)<1});
      emit('duxford:cart:updated',{count:Number(count||0)});
    }
    const pageHtml=sections['dc-main-cart'];
    if(pageHtml){
      const doc=new DOMParser().parseFromString(pageHtml,'text/html');
      const fresh=$('[data-dc-cart-page]',doc), current=$('[data-dc-cart-page]'); if(fresh&&current) current.replaceWith(fresh);
    }
  };
  const cartMutation = async (url, payload) => {
    const requested=['dc-cart-drawer']; if($('[data-dc-cart-page]')) requested.push('dc-main-cart');
    const body={...payload,sections:requested,sections_url:location.pathname};
    const res=await fetch(url,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)});
    const data=await res.json(); if(!res.ok) throw new Error(data.description || data.message || 'Cart error');
    refreshCartSections(data.sections); return data;
  };

  // Ajax product forms
  document.addEventListener('submit', async e=>{
    const form=e.target.closest('form.dc-product__form'); if(!form)return; e.preventDefault();
    const submit=form.querySelector('[type=submit]'); const msg=form.querySelector('[data-product-message]'); submit?.setAttribute('aria-busy','true'); if(msg)msg.textContent='';
    const fd=new FormData(form); const id=Number(fd.get('id')), quantity=Number(fd.get('quantity')||1); const properties={};
    for(const [k,v] of fd.entries()) if(k.startsWith('properties[')) properties[k.slice(11,-1)]=v;
    try{
      await cartMutation(cfg.cartAdd || rootUrl('cart/add.js'),{items:[{id,quantity,properties}]});
      if(cfg.cartMode==='drawer'){closeAll(); $('[data-dc-cart]')?.classList.add('is-open');overlay()?.classList.add('is-open');lock(true)} else location.href=cfg.cart;
    }catch(err){if(msg)msg.textContent=err.message;else alert(err.message)}finally{submit?.removeAttribute('aria-busy')}
  });

  // Cart line changes
  let cartChangeTimer;
  document.addEventListener('change',e=>{
    const input=e.target.closest('[data-cart-line-qty]'); if(!input)return; clearTimeout(cartChangeTimer);
    cartChangeTimer=setTimeout(async()=>{try{await cartMutation(cfg.cartChange || rootUrl('cart/change.js'),{id:input.dataset.key,quantity:Number(input.value)})}catch(err){alert(err.message)}},250);
  });
  document.addEventListener('click',async e=>{
    const remove=e.target.closest('[data-cart-remove]'); if(!remove)return;e.preventDefault();try{await cartMutation(cfg.cartChange || rootUrl('cart/change.js'),{id:remove.dataset.key,quantity:0})}catch(err){alert(err.message)}
  });

  // Pickup availability drawer.
  document.addEventListener('click',e=>{
    const open=e.target.closest('[data-pickup-open]');
    if(open){const root=open.closest('[data-product-root]')||document;const drawer=$('[data-pickup-drawer]',root);if(drawer){e.preventDefault();closeAll();drawer.classList.add('is-open');drawer.setAttribute('aria-hidden','false');lock(true);drawer.querySelector('.dc-pickup-drawer__header [data-pickup-close]')?.focus();}return;}
    const close=e.target.closest('[data-pickup-close]');
    if(close){const drawer=close.closest('[data-pickup-drawer]');if(drawer){drawer.classList.remove('is-open');drawer.setAttribute('aria-hidden','true');lock(false);}}
  });

  // Product media gallery and zoom
  const showProductMedia = (root, mediaId) => {
    if(!root || !mediaId) return;
    const slides=$$('[data-media-slide]',root), thumbs=$$('[data-media-thumb]',root);
    slides.forEach(x=>x.classList.toggle('is-active',String(x.dataset.mediaId)===String(mediaId)));
    thumbs.forEach(x=>x.classList.toggle('is-active',String(x.dataset.mediaThumb)===String(mediaId)));
    const active=root.querySelector(`[data-media-id="${mediaId}"]`);
    if(matchMedia('(max-width: 768px)').matches) active?.scrollIntoView({behavior:'smooth',block:'nearest',inline:'center'});
  };
  document.addEventListener('click',e=>{
    const arrow=e.target.closest('[data-thumb-prev],[data-thumb-next]');
    if(arrow){const wrap=arrow.closest('.dc-product__thumb-wrap'),strip=$('[data-thumb-strip]',wrap);if(strip){const beside=arrow.closest('.dc-product-gallery')?.classList.contains('dc-product-gallery--beside');const amount=95*(arrow.hasAttribute('data-thumb-prev')?-1:1);strip.scrollBy({top:beside?amount:0,left:beside?0:amount,behavior:'smooth'});}return;}
    const thumb=e.target.closest('[data-media-thumb]'); if(thumb){showProductMedia(thumb.closest('[data-product-root]'),thumb.dataset.mediaThumb);return;}
    const zoom=e.target.closest('[data-image-zoom]'); if(zoom){const modal=$('[data-dc-modal]'),content=$('[data-dc-modal-content]',modal);if(!modal||!content)return;modal.hidden=false;content.innerHTML=`<div class="dc-zoom-view"><img src="${zoom.dataset.imageZoom}" alt=""></div>`;lock(true);}
  });

  // Pickup availability via Shopify's public Section Rendering endpoint for variants
  const updatePickup = async (root, variantId) => {
    const host=$('[data-store-availability-container]',root); if(!host||!variantId)return;
    try{const res=await fetch(rootUrl(`variants/${variantId}/?section_id=dc-store-availability`),{headers:{'X-Requested-With':'XMLHttpRequest'}});if(!res.ok){host.innerHTML='';return;}const text=await res.text();const doc=new DOMParser().parseFromString(text,'text/html');host.innerHTML=$('[data-store-availability-payload]',doc)?.innerHTML||'';const title=$('[data-availability-product-title]',host);if(title)title.textContent=host.dataset.productTitle||'';}catch{host.innerHTML='';}
  };

  // Product variants - independent option matcher
  const initProduct = root => {
    if(root.dataset.dcProductInit==='true') return; root.dataset.dcProductInit='true';
    const json=$('script[data-product-json]',root); if(!json)return; let product;try{product=JSON.parse(json.textContent)}catch{return}
    let inventory={}, unitPricing={};
    const inventoryJson=$('script[data-variant-inventory-json]',root);
    if(inventoryJson){try{for(const row of JSON.parse(inventoryJson.textContent)) inventory[String(row.id)]=row}catch{inventory={}}}
    const unitJson=$('script[data-variant-unit-price-json]',root);
    if(unitJson){try{for(const row of JSON.parse(unitJson.textContent)) unitPricing[String(row.id)]=row}catch{unitPricing={}}}
    const form=$('form.dc-product__form',root), idInput=$('[data-product-id]',form); if(!form||!idInput)return;
    const controls=$$('[data-option-index]',root);
    const selected=()=>product.options.map((_,idx)=>{
      const active=root.querySelector(`[data-option-index="${idx}"] .is-selected`); if(active)return active.dataset.value;
      const select=root.querySelector(`select[data-option-select="${idx}"]`); return select?.value;
    });
    const updateOptionAvailability=values=>{
      controls.forEach((group,idx)=>{
        $$('[data-option-button]',group).forEach(button=>{
          const candidate=[...values];candidate[idx]=button.dataset.value;
          const possible=product.variants.some(v=>v.available && v.options.every((o,i)=>i===idx?o===candidate[i]:(candidate[i]==null||o===candidate[i])));
          button.classList.toggle('is-unavailable',!possible);
          button.setAttribute('aria-disabled',possible?'false':'true');
        });
        const select=$('select[data-option-select]',group);
        if(select){[...select.options].forEach(option=>{const candidate=[...values];candidate[idx]=option.value;option.disabled=!product.variants.some(v=>v.available&&v.options.every((o,i)=>i===idx?o===candidate[i]:(candidate[i]==null||o===candidate[i])));});}
      });
    };
    const apply=()=>{
      const values=selected(); updateOptionAvailability(values);
      controls.forEach((group,idx)=>{const label=$('[data-selected-value]',group);if(label)label.textContent=values[idx]||''});
      const variant=product.variants.find(v=>v.options.every((o,i)=>o===values[i]));
      const submit=$('[data-product-submit]',root);
      if(!variant){if(submit){submit.disabled=true;submit.textContent=submit.dataset.soldText||'Unavailable'}return;}
      idInput.value=variant.id;
      const price=$('[data-product-price]',root), compare=$('[data-product-compare]',root), save=$('[data-product-save]',root), priceWrap=$('[data-price-wrap]',root);
      if(price)price.textContent=money(variant.price);
      const onSale=Number(variant.compare_at_price||0)>Number(variant.price||0);
      if(compare){compare.textContent=onSale?money(variant.compare_at_price):'';compare.hidden=!onSale}
      if(priceWrap?.dataset.saveEnabled==='true'){
        let saveNode=save;
        if(onSale){
          const saved=variant.compare_at_price-variant.price;
          const amount=priceWrap.dataset.saveType==='percent'?`${Math.round(saved*100/variant.compare_at_price)}%`:money(saved);
          if(!saveNode){saveNode=document.createElement('span');saveNode.className='dc-price__save';saveNode.dataset.productSave='';priceWrap.append(saveNode);}
          saveNode.textContent=(priceWrap.dataset.saveLabel||'Save __AMOUNT__').replace('__AMOUNT__',amount);saveNode.hidden=false;
        }else if(saveNode)saveNode.hidden=true;
      }
      const unit=unitPricing[String(variant.id)]||{};
      $$('[data-unit-price-wrapper]',root).forEach(wrapper=>{
        const show=Boolean(unit.has_measurement);
        wrapper.hidden=!show;
        if(show){
          const unitPrice=$('[data-unit-price]',wrapper),unitBase=$('[data-unit-base]',wrapper);
          if(unitPrice)unitPrice.textContent=money(Number(unit.unit_price||0));
          if(unitBase)unitBase.textContent=`${Number(unit.reference_value||1)!==1?unit.reference_value:''}${unit.reference_unit||''}`;
        }
      });
      if(submit){submit.disabled=!variant.available;submit.textContent=variant.available?(submit.dataset.addText||'Add to cart'):(submit.dataset.soldText||'Sold out')}
      const sku=$('[data-product-sku]',root); if(sku)sku.textContent=variant.sku||'';
      const inv=inventory[String(variant.id)]||{};
      $$('[data-inventory-status]',root).forEach(node=>{
        const threshold=Number(node.dataset.threshold||0),qty=Number(inv.quantity||0);
        const tracked=inv.management==='shopify',low=tracked&&inv.policy!=='continue'&&qty>0&&qty<=threshold;
        node.hidden=!variant.available;
        node.classList.toggle('is-low',low);
        const message=$('[data-inventory-message]',node);
        if(message)message.textContent=low?`${node.dataset.labelLow||'Only left'} ${qty}`:(node.dataset.labelInStock||'In stock');
      });
      $$('[data-incoming-inventory]',root).forEach(node=>{
        const threshold=Number(node.previousElementSibling?.dataset?.threshold||0),qty=Number(inv.quantity||0);
        const low=inv.management==='shopify'&&inv.policy!=='continue'&&qty>0&&qty<=threshold;
        const show=Boolean(inv.incoming)&&!low&&qty<=threshold;
        node.hidden=!show;
        if(show)node.textContent=inv.incoming_date?`${node.dataset.labelArriving||'Expected'} ${inv.incoming_date}`:(node.dataset.labelWaiting||'Inventory on the way');
      });
      if(history.replaceState && root.dataset.updateUrl==='true'){const u=new URL(location.href);u.searchParams.set('variant',variant.id);history.replaceState({},'',u)}
      if(variant.featured_media) showProductMedia(root,variant.featured_media.id)
      updatePickup(root,variant.id);
      emit('duxford:variant:change',{variant,product});
    };
    root.addEventListener('click',e=>{const b=e.target.closest('[data-option-button]');if(!b)return;const group=b.closest('[data-option-index]');$$('[data-option-button]',group).forEach(x=>x.classList.remove('is-selected'));b.classList.add('is-selected');apply()});
    root.addEventListener('change',e=>{if(e.target.matches('[data-option-select]'))apply()});
    apply();
  };
  $$('[data-product-root]').forEach(initProduct);
  document.addEventListener('shopify:section:load',e=>$$('[data-product-root]',e.target).forEach(initProduct));

  // Quick View. Load the product's real storefront template so the modal
  // inherits its configured product blocks instead of the empty alternate template.
  const openQuickView=async q=>{
    if(!q)return;
    const modal=$('[data-dc-modal]'),content=$('[data-dc-modal-content]',modal);if(!modal||!content)return;
    modal.hidden=false;lock(true);content.innerHTML='<div class="dc-empty">Loading…</div>';
    try{
      const card=q.closest('[data-product-card]');
      const productLink=card?.querySelector('.dc-card__media')?.href || rootUrl(`products/${q.dataset.quickView}`);
      const url=new URL(productLink,location.origin);url.searchParams.set('_dc_quick','1');
      const res=await fetch(url.toString(),{headers:{'X-Requested-With':'XMLHttpRequest'}});
      if(!res.ok)throw new Error(`Quick view HTTP ${res.status}`);
      const text=await res.text();const doc=new DOMParser().parseFromString(text,'text/html');const root=$('[data-product-root]',doc);
      if(!root)throw new Error('Quick view product root missing');
      root.dataset.updateUrl='false';
      content.replaceChildren(root);
      initProduct(root);
      try{window.Shopify?.PaymentButton?.init?.()}catch{}
      content.scrollTop=0;
      modal.querySelector('.dc-modal__panel')?.scrollTo({top:0});
    }catch(err){console.error('[Duxford] Quick View',err);content.innerHTML='<div class="dc-empty">Unable to load product.</div>'}
  };
  document.addEventListener('click',e=>{const q=e.target.closest('[data-quick-view]');if(!q)return;e.preventDefault();e.stopPropagation();openQuickView(q)});
  document.addEventListener('keydown',e=>{const q=e.target.closest('[data-quick-view]');if(!q||!(e.key==='Enter'||e.key===' '))return;e.preventDefault();e.stopPropagation();openQuickView(q)});
  document.addEventListener('click',e=>{if(e.target.closest('[data-dc-modal-close]')){const m=$('[data-dc-modal]');m.hidden=true;lock(false)}});

  // Collection sorting and filters
  document.addEventListener('change',e=>{
    const sort=e.target.closest('[data-sort-by]');if(sort){const u=new URL(location.href);if(sort.value)u.searchParams.set('sort_by',sort.value);else u.searchParams.delete('sort_by');location.href=u.toString()}
    const auto=e.target.closest('[data-filter-auto]');if(auto) auto.form?.submit();
  });

  // Map section: public Google Maps JS API with the reference interaction contract.
  let dcMapsPromise;
  const loadMapsApi=key=>{
    if(window.google?.maps)return Promise.resolve(window.google.maps);
    if(dcMapsPromise)return dcMapsPromise;
    dcMapsPromise=new Promise((resolve,reject)=>{
      const script=document.createElement('script');
      script.src=`https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(key)}`;
      script.async=true;script.defer=true;script.onload=()=>resolve(window.google?.maps);script.onerror=reject;document.head.appendChild(script);
    });
    return dcMapsPromise;
  };
  const mapError=(el,message)=>{if(!window.Shopify?.designMode)return;const section=el.closest('[data-map-section]');if(!section)return;let node=$('.dc-map-error',section);if(!node){node=document.createElement('div');node.className='dc-map-error';section.append(node)}node.textContent=message||'Map error';};
  const initMap=async el=>{
    if(el.dataset.dcMapInit==='true')return;el.dataset.dcMapInit='true';const key=el.dataset.apiKey,address=el.dataset.address;if(!key||!address)return;
    try{
      const maps=await loadMapsApi(key);if(!maps)throw new Error('maps');
      const geocoder=new maps.Geocoder();
      geocoder.geocode({address},(results,status)=>{
        if(status!=='OK'||!results?.[0]){const msg=status==='ZERO_RESULTS'?el.dataset.errorResults:status==='OVER_QUERY_LIMIT'?el.dataset.errorLimit:status==='REQUEST_DENIED'?el.dataset.errorAuth:el.dataset.errorAddress;mapError(el,msg);return;}
        const center=results[0].geometry.location;
        const map=new maps.Map(el,{zoom:14,backgroundColor:'transparent',center,draggable:false,clickableIcons:false,scrollwheel:false,disableDoubleClickZoom:true,disableDefaultUI:true});
        new maps.Marker({map,position:center});
        let resizeTimer;addEventListener('resize',()=>{clearTimeout(resizeTimer);resizeTimer=setTimeout(()=>{maps.event.trigger(map,'resize');map.setCenter(center)},250)},{passive:true});
      });
    }catch{mapError(el,el.dataset.errorAuth||el.dataset.errorAddress)}
  };
  const initMaps=root=>$$('[data-dc-map]',root).forEach(initMap);
  initMaps(document);
  document.addEventListener('shopify:section:load',e=>initMaps(e.target));

  // Newsletter popup — editor mode is immediate, storefront mode honors delay/frequency.
  const initPopup=pop=>{
    if(pop.dataset.dcPopupInit==='true')return;pop.dataset.dcPopupInit='true';
    const mode=pop.dataset.mode, key='dcPopupDismissed', days=Number(pop.dataset.days||30), delay=Number(pop.dataset.delay||5)*1000; if(mode==='disabled')return;
    const show=()=>{pop.hidden=false;lock(true)};
    const dismissed=Number(localStorage.getItem(key)||0), expired=Date.now()-dismissed>days*86400000;
    if(window.Shopify?.designMode) show(); else if(mode==='testing'||expired)setTimeout(show,delay);
    const close=(remember=true)=>{pop.hidden=true;lock(false);if(remember&&mode!=='testing'&&!window.Shopify?.designMode)localStorage.setItem(key,String(Date.now()))};
    pop._dcClose=close;
    pop.addEventListener('click',e=>{if(e.target.closest('[data-popup-close]')||e.target===pop)close(true)});
  };
  $$('[data-newsletter-popup]').forEach(initPopup);
  document.addEventListener('shopify:section:load',e=>$$('[data-newsletter-popup]',e.target).forEach(initPopup));
  document.addEventListener('shopify:section:select',e=>{const pop=e.target.matches?.('[data-newsletter-popup]')?e.target:$('[data-newsletter-popup]',e.target);if(pop){pop.hidden=false;lock(true)}});

  // Recently viewed: product JSON + the same dc-card visual contract used by collection grids.
  const esc = value => String(value ?? '').replace(/[&<>'"]/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[c]));
  const readRecent = () => {try{return JSON.parse(localStorage.getItem('dcRecentProducts')||'[]')}catch{return []}};
  const writeRecent = handles => {try{localStorage.setItem('dcRecentProducts',JSON.stringify(handles.slice(0,12)))}catch{}};
  const rememberCurrentProduct = () => {
    const productRoot=$('[data-product-root][data-product-handle]');if(!productRoot)return;
    const handle=productRoot.dataset.productHandle;if(!handle)return;
    const handles=readRecent().filter(x=>x&&x!==handle);handles.unshift(handle);writeRecent(handles);
  };
  const buildRecentCard = (p, section) => {
    const ratio=section.dataset.imageRatio||'natural';
    const image=p.featured_image||p.images?.[0]||'';
    return `<article class="dc-card" data-product-card><a class="dc-card__media dc-ratio--${esc(ratio)}${section.dataset.imageFill==='true'?' dc-card__media--fill':''}" href="${esc(p.url)}">${image?`<img class="dc-card__image dc-card__image--primary" loading="lazy" src="${esc(image)}" alt="${esc(p.title)}">`:''}</a><div class="dc-card__body"><a class="dc-card__title" href="${esc(p.url)}">${esc(p.title)}</a></div></article>`;
  };
  const initRecentlyViewed = async section => {
    if(window.Shopify?.designMode){section.hidden=true;return}
    const handles=readRecent().filter(h=>h&&h!==section.dataset.current).slice(0,Number(section.dataset.limit||5));
    const grid=$('[data-recent-grid]',section);if(!grid||!handles.length){section.hidden=true;return}
    const products=(await Promise.all(handles.map(async handle=>{try{const r=await fetch(rootUrl(`products/${encodeURIComponent(handle)}.js`));return r.ok?await r.json():null}catch{return null}}))).filter(Boolean);
    if(!products.length){section.hidden=true;return}
    grid.innerHTML=products.map(p=>buildRecentCard(p,section)).join('');section.hidden=false;
  };
  rememberCurrentProduct();
  $$('[data-recently-viewed]').forEach(initRecentlyViewed);
  document.addEventListener('shopify:section:load',e=>$$('[data-recently-viewed]',e.target).forEach(initRecentlyViewed));


  // Product recommendations: public recommendations endpoint, with support for merchant _related collections rendered server-side.
  const initRecommendations = async root => {
    if(root.dataset.dcRecommendationsInit==='true'||root.dataset.enable!=='true')return;root.dataset.dcRecommendationsInit='true';
    if(root.innerHTML.trim())return;
    try{const r=await fetch(root.dataset.url,{headers:{'X-Requested-With':'XMLHttpRequest'}});if(!r.ok)return;const text=await r.text();const doc=new DOMParser().parseFromString(text,'text/html');const fresh=$('[data-recommendations-root]',doc);if(fresh?.innerHTML.trim())root.innerHTML=fresh.innerHTML;}catch{}
  };
  $$('[data-recommendations-root]').forEach(initRecommendations);
  document.addEventListener('shopify:section:load',e=>$$('[data-recommendations-root]',e.target).forEach(initRecommendations));

  // Customer account forms: recovery and address editor use only native storefront forms.
  const syncProvince = country => {
    const form=country.closest('form'), province=$('[data-address-province]',form), wrap=$('[data-province-wrap]',form); if(!province||!wrap)return;
    const opt=country.options[country.selectedIndex]; let rows=[];try{rows=JSON.parse(opt?.dataset.provinces||'[]')}catch{rows=[]}
    province.innerHTML=rows.map(([value,label])=>`<option value="${esc(value)}">${esc(label)}</option>`).join('');
    wrap.hidden=!rows.length;
    if(rows.length&&province.dataset.default){const match=[...province.options].find(x=>x.value===province.dataset.default);if(match)province.value=match.value;}
  };
  const initCustomerForms = root => {
    $$('[data-address-country]',root).forEach(country=>{if(country.dataset.dcCountryInit==='true')return;country.dataset.dcCountryInit='true';if(country.dataset.default){const match=[...country.options].find(x=>x.value===country.dataset.default||x.textContent.trim()===country.dataset.default);if(match)country.value=match.value;}syncProvince(country);country.addEventListener('change',()=>syncProvince(country));});
    const recover=$('[data-recover-form]',root),login=$('[data-customer-login]',root);
    if(recover&&login&&(location.hash==='#recover'||$('[data-reset-success]',recover))){recover.hidden=false;login.hidden=true;}
  };
  document.addEventListener('click',e=>{
    if(e.target.closest('[data-recover-open]')){e.preventDefault();const r=$('[data-recover-form]'),l=$('[data-customer-login]');if(r&&l){r.hidden=false;l.hidden=true;history.replaceState?.({},'',`${location.pathname}${location.search}#recover`);}}
    if(e.target.closest('[data-recover-close]')){const r=$('[data-recover-form]'),l=$('[data-customer-login]');if(r&&l){r.hidden=true;l.hidden=false;history.replaceState?.({},'',`${location.pathname}${location.search}`);}}
    const add=e.target.closest('[data-address-new-toggle]');if(add){const box=$('[data-address-new]');if(box){box.hidden=!box.hidden;if(!box.hidden)box.querySelector('input')?.focus();}}
    const edit=e.target.closest('[data-address-edit-toggle]');if(edit){const box=document.querySelector(`[data-address-edit="${CSS.escape(edit.dataset.addressEditToggle)}"]`);if(box){box.hidden=!box.hidden;if(!box.hidden)box.querySelector('input')?.focus();}}
    const del=e.target.closest('[data-address-delete]');if(del){const message=del.dataset.confirm||'Delete this address?';if(!confirm(message))return;const form=document.createElement('form');form.method='post';form.action=rootUrl(`account/addresses/${encodeURIComponent(del.dataset.addressDelete)}`);form.innerHTML='<input type="hidden" name="_method" value="delete">';document.body.append(form);form.submit();}
  });
  initCustomerForms(document);
  document.addEventListener('shopify:section:load',e=>initCustomerForms(e.target));


  // Product-card color swatches preview the matching variant image on desktop.
  const setCardSwatchPreview=(swatch,on)=>{
    const card=swatch.closest('[data-product-card]'), image=$('.dc-card__image--primary',card);if(!card||!image)return;
    if(on&&swatch.dataset.swatchImage){
      if(!image.dataset.dcOriginalSrc)image.dataset.dcOriginalSrc=image.currentSrc||image.src||'';
      if(!image.dataset.dcOriginalSrcset&&image.getAttribute('srcset'))image.dataset.dcOriginalSrcset=image.getAttribute('srcset');
      image.removeAttribute('srcset');image.src=swatch.dataset.swatchImage;card.classList.add('is-swatch-preview');
    }else{
      if(image.dataset.dcOriginalSrcset)image.setAttribute('srcset',image.dataset.dcOriginalSrcset);
      if(image.dataset.dcOriginalSrc)image.src=image.dataset.dcOriginalSrc;
      card.classList.remove('is-swatch-preview');
    }
  };
  document.addEventListener('pointerover',e=>{const s=e.target.closest('[data-product-swatch]');if(s&&matchMedia('(hover:hover)').matches)setCardSwatchPreview(s,true)});
  document.addEventListener('pointerout',e=>{const s=e.target.closest('[data-product-swatch]');if(s&&(!e.relatedTarget||!s.contains(e.relatedTarget)))setCardSwatchPreview(s,false)});
  document.addEventListener('focusin',e=>{const s=e.target.closest('[data-product-swatch]');if(s)setCardSwatchPreview(s,true)});
  document.addEventListener('focusout',e=>{const s=e.target.closest('[data-product-swatch]');if(s)setCardSwatchPreview(s,false)});
})();
